module.exports = __webpack_public_path__ + "media/icons/triangle_border-d555ce8e.svg";